<template>
    <div>
        <!-- Mobile Toggle Button -->
        <button v-if="isMobile" @click="toggleSidebar"
            class="lg:hidden fixed top-4 right-14 z-50 h-8 w-8 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-gray-700" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
        </button>

        <!-- Overlay for mobile -->
        <div v-if="isMobile && isOpen" class="fixed inset-0 bg-black bg-opacity-50 z-40" @click="toggleSidebar">
        </div>

        <!-- Sidebar -->
        <div class="w-48 bg-gray-50 border-r h-full flex flex-col transition-transform duration-300 ease-in-out" :class="[
            isMobile ? 'fixed top-0 right-0 z-50 h-screen' : '',
            isMobile && !isOpen ? 'translate-x-full' : 'translate-x-0'
        ]">

            <div class="pt-2 pb-2 px-4 text-[15px] font-semibold text-gray-400 px-6 py-2">MENU</div>
            <div class="flex flex-col gap-1 px-2">
                <button @click="handleNavigation('calendar')"
                    class="flex items-center h-8 rounded-lg px-4 py-2 w-full text-[14px]"
                    :class="$route.path === '/calendar' ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:bg-gray-50'">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    Calendar
                </button>
                <button @click="handleNavigation('analytics')"
                    class="flex items-center h-8 rounded-lg px-4 py-2 w-full text-[14px]"
                    :class="$route.path === '/analytics' ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:bg-gray-50'">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 17v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                    Analytics
                </button>
                <button @click="handleNavigation('content-library')"
                    class="flex items-center h-8 rounded-lg px-4 py-2 w-full text-[14px]"
                    :class="$route.path === '/content-library' ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:bg-gray-50'">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                    Content Library
                </button>
                <!-- <button @click="handleNavigation('settings')"
                    class="flex items-center h-8 rounded-lg px-4 py-2 w-full text-[14px]"
                    :class="$route.path === '/settings' ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:bg-gray-50'">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Settings
                </button> -->
            </div>
            <div class="pt-4 pb-4 px-6 text-[15px] font-semibold text-gray-400">PLATFORMS</div>
            <div class="flex flex-col gap-1 px-4">
                <div class="flex items-center h-7 rounded-lg mb-1 px-2 py-2"
                    :class="{ 'bg-blue-50': selectedPlatform === 'all' }" @click="selectPlatform('all')"
                    style="cursor:pointer">
                    <span class="text-blue-600 text-[14px] font-medium ml-2"
                        :class="{ 'text-blue-600': selectedPlatform === 'all' }">All Platforms</span>
                </div>
                <div class="flex items-center h-7 rounded-lg px-4 py-2"
                    :class="{ 'bg-blue-50': selectedPlatform === 'OnlyFans' }" @click="selectPlatform('OnlyFans')"
                    style="cursor:pointer">
                    <span class="h-2 w-2 rounded-full bg-red-500 mr-2"></span>
                    <span class="text-gray-700 text-[14px]">OnlyFans</span>
                </div>
                <div class="flex items-center h-7 rounded-lg px-4 py-2"
                    :class="{ 'bg-blue-50': selectedPlatform === 'Fansly' }" @click="selectPlatform('Fansly')"
                    style="cursor:pointer">
                    <span class="h-2 w-2 rounded-full bg-pink-500 mr-2"></span>
                    <span class="text-gray-700 text-[14px]">Fansly</span>
                </div>
                <div class="flex items-center h-7 rounded-lg mb-2 px-4 py-2"
                    :class="{ 'bg-blue-50': selectedPlatform === 'ManyVids' }" @click="selectPlatform('ManyVids')"
                    style="cursor:pointer">
                    <span class="h-2 w-2 rounded-full bg-blue-500 mr-2"></span>
                    <span class="text-gray-700 text-[14px]">ManyVids</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalendarSidebar',
    data() {
        return {
            selectedPlatform: 'all',
            isOpen: false,
            isMobile: false
        }
    },
    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        checkScreenSize() {
            this.isMobile = window.innerWidth < 1024; // lg breakpoint
            if (!this.isMobile) {
                this.isOpen = true;
            }
        },
        toggleSidebar() {
            this.isOpen = !this.isOpen;
        },
        handleNavigation(route) {
            this.$emit(route);
            if (this.isMobile) {
                this.isOpen = false;
            }
        },
        selectPlatform(platform) {
            this.selectedPlatform = platform;
            this.$emit('platform-selected', platform);
        }
    }
}
</script>

<style scoped>
@media (max-width: 1023px) {
    .w-48 {
        width: 16rem;
    }
}
</style>